import { Module } from '@nestjs/common';
import { MikroOrmModule } from '@mikro-orm/nestjs';
import { FileController } from './controllers/file.controller';
import { FileService } from './services/file.service';
import { File } from './entities/file.entity';
import { MulterModule } from '@webundsoehne/nest-fastify-file-upload';
import { ConfigService } from '@nestjs/config';
import { UtilsService } from '../../shared/utils/utils.service';

@Module({
  imports: [
    MikroOrmModule.forFeature([File]),
    MulterModule.register({}),
  ],
  controllers: [FileController],
  providers: [FileService, UtilsService],
  exports: [FileService],
})
export class FileModule {}
